/**
 * Language type.
 * Note: there is no translations currently for 'en' (but it is referenced e.g. in 'utils.ts').
 */
export type Language = 'fi' | 'en'

export const defaultLanguage: Language = 'fi'
